var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-action"},[_c('p',[_vm._v(_vm._s(_vm.texts[_vm.type]))]),_vm._v("   "),_c('router-link',{attrs:{"to":{ name: _vm.links[_vm.type], query: _vm.$route.query, hash: _vm.$route.hash }}},[_vm._v(" "+_vm._s(_vm.actions[_vm.type])+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }